import { BUSINESS_RULES, getBusinessRules } from '@ngb-frontend/shared/rules'
import { Organization, SystemCode } from '@ngb-frontend/shared/types'

import type { QueryCountryCode } from '@ngb-frontend/shared/types'

// Country → org (only LPUK is LeasePlan) is derived from the country registry,
// which owns the per-country `org`. GLOBAL has no registry entry (defaults).
const COUNTRY_CODES = [
  ...Object.keys(BUSINESS_RULES),
  'GLOBAL',
] as QueryCountryCode[]

export const countryCodeToOrg = Object.fromEntries(
  COUNTRY_CODES.map((code) => [code, getBusinessRules(code).org]),
) as Record<QueryCountryCode, `${Organization}`>

export const systemCodeToOrg: Record<`${SystemCode}`, `${Organization}`> = {
  [SystemCode.MYAY]: Organization.AYVENS,
  [SystemCode.SFALD]: Organization.AYVENS,
  [SystemCode.FLEETMNGR]: Organization.AYVENS,
  [SystemCode.SFLP]: Organization.LP,
  [SystemCode.SPLP]: Organization.LP,
  [SystemCode.MYLP]: Organization.LP,
}
